import { Modal } from "shared/components";
import { PromoContentComponentProps, PromoType } from "../types";
import { useState } from "react";
import { PromoContent } from "../Content";

export const PromoModal = (
  props: Omit<PromoContentComponentProps, "promoType">
) => {
  const [isOpened, setIsOpened] = useState(true);

  return (
    <Modal opened={isOpened} onClose={() => setIsOpened(false)}>
      <PromoContent
        {...props}
        promoType={PromoType.Modal}
        onClose={() => {
          props.onClose?.();
          setIsOpened(false);
        }}
      />
    </Modal>
  );
};
